import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames/bind';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const ListingPage = ({ slots, className = '' }) => {
    return (_jsxs("div", { className: cx('container', 'column', className), children: [slots?.nav && _jsx("div", { className: cx('nav'), children: slots?.nav?.() }), _jsxs("div", { className: cx('row'), children: [slots?.left && _jsx("div", { className: cx('left'), children: slots?.left?.() }), slots?.main && _jsx("div", { className: cx('main'), children: slots?.main?.() })] })] }));
};
export default ListingPage;
//# sourceMappingURL=index.js.map